export default "__VITE_ASSET__BFW4NIV2__";